import React from 'react'
import block from 'bem-cn'

import Spinner from 'components/Spinner'

import './PageLoading.scss'

const b = block('page-loading')

export const PageLoading: React.FC<{ isLoading: boolean }> = ({ isLoading }) => isLoading ? (
    <div className={b()}>
      <Spinner isLoading />
    </div>
  ) : null
